const MuiSvgIconOverrides = {
  MuiSvgIcon: {
    defaultProps: {
      fontSize: 'small'
    }
  }
};

export { MuiSvgIconOverrides };
